<template>
    <div class="flex items-center space-x-2">
        <select 
            :value="props.role"
            @change="updateRole($event.target.value)"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-indigo-500 dark:focus:border-indigo-500">
            <option value="readonly">Read Only</option>
            <option value="editor">Editor</option>
        </select>
        <Button @click="onRemove" type="danger" class="!px-3 !py-2 !ms-0">
            Remove
        </Button>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import Button from '@/components/form/TriadButton.vue';

const props = defineProps({
    role: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['update-role', 'remove']);

const updateRole = (newRole) => {
    emit('update-role', newRole);
};

const onRemove = () => {
    emit('remove');
};
</script> 